import { render, staticRenderFns } from "./ModalEditarFornecedor.vue?vue&type=template&id=f642857e&"
import script from "./ModalEditarFornecedor.vue?vue&type=script&lang=js&"
export * from "./ModalEditarFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarFornecedor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports